import { FlatpickrDirective, provideFlatpickrDefaults } from "angularx-flatpickr";

import { formatDate } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";

import { MessageService } from "../../../services/messageservice";

@Component({
  selector: "webarchive-calendar",
  templateUrl: "webarchive-calendar.html",
  styleUrls: ["webarchive-calendar.scss"],
  imports: [FlatpickrDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [provideFlatpickrDefaults()],
})
export class WebarchiveCalendar {
  private msgsrv = inject(MessageService);

  readonly year = input.required<number>();
  readonly webarchiveData = input.required<Map<number, { [key: string]: any }>>();

  protected months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  onDayCreate(parameter: { dayElement: HTMLElement }) {
    // @ts-ignore
    const dateString = formatDate(parameter.dayElement.dateObj, "yyyy-MM-dd", "en-US");
    // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
    const maintenanceArray: [string] = this.webarchiveData().get(this.year()).get("maintenance");
    // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
    const malfunctionArray: [string] = this.webarchiveData().get(this.year()).get("malfunction");
    if (maintenanceArray.includes(dateString)) {
      parameter.dayElement.className += " event event-maintenance";
    }
    if (malfunctionArray.includes(dateString)) {
      parameter.dayElement.className += " event event-malfunction";
    }
  }

  onDayChange(parameter: { dateString: string }) {
    const msg = {
      filterDate: new Date(parameter.dateString),
    };
    this.msgsrv.setMalfunctionFilterDate(msg);
  }
}
